import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useResponseFormHandler } from 'src/utils/hooks/useResponseFormHandler';
import { useFetch } from 'src/utils/hooks/useFetch';
import { EventsApi } from 'src/api/base/Events';

import { ICreateGuestModel, IGuestInfo } from 'src/api/base/Guest/types';

import { EventsEventsForm } from './EventsEventsForm';

export const EventsEventsFormCreate: React.FC = () => {
  const [{ response, isLoading, error }, doFetch] = useFetch<
    any,
    ICreateGuestModel
  >(EventsApi.createEvents);
  const history = useHistory();

  useResponseFormHandler({ error, response });

  useEffect(() => {
    if (response) {
      history.push('/');
      // onSuccess(response?.data?.data);
    }
  }, [history, response]);

  return (
    <EventsEventsForm
      onSubmit={(data) => {
        doFetch(data);
      }}
      loading={isLoading}
      errors={error?.response?.data.errors}
      shouldResetAfterSuccess={response}
    />
  );
};

export const EventsEventsFormUpdate: React.FC = () => {
  const [{ response }, doFetch] = useFetch<any, any>(EventsApi.getSingleEvents);

  const { id } = useParams();

  useEffect(() => {
    doFetch(id);
  }, [id, doFetch]);

  const [
    { response: responseEdit, isLoading: isLoadingEdit, error: errorEdit },
    doEdit,
  ] = useFetch<any, any>(EventsApi.updateEvents);

  useResponseFormHandler({ response: responseEdit, error: errorEdit });

  return (
    <EventsEventsForm
      loading={isLoadingEdit}
      onSubmit={(data) => {
        doEdit({ id, data });
      }}
      errors={errorEdit?.response?.data?.errors}
      eventsTemplate={
        responseEdit?.data?.data?.data || response?.data?.data?.data
      }
      shouldResetAfterSuccess={responseEdit}
    />
  );
};
